<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      ip: "",
      input: {
        firstname: "",
        lastname: "",
      },
      response: "",
    };
  },
  mounted() {
    this.$http.get("https://httpbin.org/ip").then(
      (result) => {
        this.ip = result.body.origin;
      },
      (error) => {
        console.error(error);
      }
    );
  },
  methods: {
    sendData() {
      this.$http
        .post("https://httpbin.org/post", this.input, {
          headers: { "content-type": "application/json" },
        })
        .then(
          (result) => {
            this.response = result.data;
          },
          (error) => {
            console.error(error);
          }
        );
    },
  },
};
</script>
